var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserManual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9126 22.4439C2.9126 23.3034 3.60935 24.0002 4.46885 24.0002H21.7907C22.179 24.0002 22.4938 23.6854 22.4938 23.2971V20.8877H4.46885C3.60935 20.8877 2.9126 21.5844 2.9126 22.4439Z",
    fill: "#022CE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61885 19.4812V0H4.4688C2.83525 0 1.50635 1.329 1.50635 2.9625V22.4437C1.50635 20.8102 2.8353 19.4812 4.4688 19.4812H4.61885Z",
    fill: "#022CE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H21.7656C22.1539 0 22.4687 0.314812 22.4687 0.703125V19.4813H6V0ZM17.3354 9.92208C17.6447 9.72567 17.6447 9.27433 17.3354 9.07792L11.2681 5.22464C10.9352 5.01323 10.5 5.25237 10.5 5.64671L10.5 13.3533C10.5 13.7476 10.9352 13.9868 11.2681 13.7754L17.3354 9.92208Z",
    fill: "#022CE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManual);
export default __webpack_public_path__ + "static/media/user_manual.7b4e7742.svg";
export { ForwardRef as ReactComponent };